import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../../assets/images/jason-logo.png'
import CartIcon from '../../../assets/images/cart.svg';

const HeaderTopBar = ({ loggedUser, onSettingsMenuClick, toggleSettingsMenu, settingsMenuVisibility, productsCount }) => {

  return (
    <div className="header-top">
      <div className="container">
        <div className="left-nav">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="extra-link">
              <Link to="/contact">Map & Directions</Link>
            </li>
          </ul>

        </div>
        <div className="right-nav">
          {loggedUser
            ? (
              <ul className="settings-menu">
                <li>
                  <a href="javascript:void(0)" onClick={() => toggleSettingsMenu
                    ? toggleSettingsMenu()
                    : null}>{loggedUser.name
                      ? `Hi ${loggedUser.name.first} ${loggedUser.name.last}`
                      : ''}
                    <i className="fa fa-caret-down"></i>
                  </a>
                  {settingsMenuVisibility
                    ? (
                      <ul>
                        <li>
                          <Link to="/settings?edit=profile">Profile</Link>
                        </li>
                        <li>
                          <Link to="/settings?edit=orders" onClick={() => onSettingsMenuClick
                            ? onSettingsMenuClick('orders')
                            : null}>Orders</Link>
                        </li>
                        <li>
                          <Link to="/settings?edit=payment-methods" onClick={() => onSettingsMenuClick
                            ? onSettingsMenuClick('payment-methods')
                            : null}>Payment Methods</Link>
                        </li>
                        <li>
                          <Link to="/" onClick={() => onSettingsMenuClick
                            ? onSettingsMenuClick('logout')
                            : null}>Logout</Link>
                        </li>
                      </ul>
                    )
                    : null}
                </li>
              </ul>
            )
            : (
              <ul>
                <li>
                  <Link to="/signup">Register</Link>
                </li>
                <li>
                  <Link to="/signin">Sign In</Link>
                </li>
              </ul>
            )}
          <Link to="/cart" className="cart-link">
            <img src={CartIcon} alt="cart icon"/> {productsCount
              ? (
                <div className="count-indicator">{productsCount}</div>
              )
              : null}

          </Link>
        </div>
      </div>
    </div>
  )
}

export default HeaderTopBar;



// WEBPACK FOOTER //
// ./src/components/commons/header/HeaderTop.js